module.exports = __webpack_public_path__ + "img/order_box_image.0ef44051.png";